import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-Arrow-Down1",
  "use": "icon-Arrow-Down1-usage",
  "viewBox": "0 0 12 12",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 12\" id=\"icon-Arrow-Down1\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M6.5 2a.5.5 0 1 0-1 0v6.586L3.525 6.61a.5.5 0 0 0-.707.707l2.828 2.828a.5.5 0 0 0 .707 0l2.829-2.828a.5.5 0 1 0-.707-.707L6.5 8.586V2Z\" fill=\"#CF1322\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol